<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :hot-key-grid-tab-index="2"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Sales Order"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="model.CustomerName"
        v-if="model.CustomerName"
      />
    </template>

    <gc-tabs
      :tabs="tabs"
      :selected-index.sync="selectedIndex"
      v-if="applicationMode == 'GcorpRoam'"
    />
    <div>
      <dx-data-grid
        :data-source="dataSourceConfig"
        :columns="columns"
        :height="gridHeight"
        @toolbar-preparing="onToolbarPreparing($event)"
        ref="'salesorderedigrid'"
        @content-ready="addGridNoResults($event)"
      >
        <template #primaryImageTemplate="{ data }">
          <div>
            <GcGridProductImage
              :ItemCode="data.data.ItemCode"
              :HasPrimaryImage="data.data.HasPrimaryImage"
              :Description="data.data.ItemDescription"
            />
          </div>
        </template>

        <template #menu-cell-template="{ data }">
          <DxDropDownButton
            :items="[{ menuText: 'Print SSCC Label', data: data }]"
            keyExpr="menuText"
            displayExpr="menuText"
            :drop-down-options="{ width: 250 }"
            class="gc-dropdown-icon-button"
            :id="data.data.SSCC"
            :icon="menu.icon"
            styling-mode="text"
            :show-arrow-icon="false"
            :onItemClick="onItemClick"
            :visible="formsConfig.editableOption"
          />
        </template>

        <template #statusTemplate>
          <gc-status-chip :status="statusFriendly" />
        </template>
      </dx-data-grid>
    </div>
  </gc-main-layout>
</template>

<script>
import { SalesOrderEDIService } from "../../_services/api/sales/sales-order-edi.service";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import BaseViewMixin from "../../v1/_mixins/base.view";
import { mapGetters } from "vuex";

export default {
  props: {},
  components: {
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      model: {
        CustomerCode: "",
        CustomerName: "",
        Name: "",
        Status: "A",
      },
      toolbar: {
        menu: {
          items: [
            { menuText: "Print SSCC Labels" },
            { menuText: "Invoice Order" },
            { menuText: "Send ASN" },
            { menuText: "Send INV" },
          ],
          keyExpr: "menuText",
          displayExpr: "menuText",
          icon: "more",
          showArrowIcon: false,
          dropDownOptions: {
            width: "200px",
          },
          stylingMode: "text",
          onItemClick: async (e) => {
            let salesOrder = parseInt(this.baseView.id);
            this.showLoading(true);
            if (e.itemData.menuText == "Print SSCC Labels") {
              SalesOrderEDIService.printSalesOrderSSCC(salesOrder)
                // eslint-disable-next-line no-unused-vars
                .then((result) => {
                  this.showLoading(false);
                  this.$notify(
                    `Successfully queued Sales Order ${salesOrder} for SSCC label printing`,
                    "success"
                  );
                  // this.$logger.debug("result ", result);
                })
                .catch((error) => {
                  this.showLoading(false);
                  this.displayServerError(error, "Print SSCC Labels Failed");
                });
            } else if (e.itemData.menuText == "Invoice Order") {
              SalesOrderEDIService.invoiceSalesOrder(salesOrder)
                // eslint-disable-next-line no-unused-vars
                .then((result) => {
                  this.showLoading(false);
                  this.$notify(
                    `Successfully invoiced Sales Order ${salesOrder}`,
                    "success"
                  );
                  this.getSalesOrder();
                  // this.$logger.debug("result ", result);
                })
                .catch((error) => {
                  this.showLoading(false);
                  this.displayServerError(error, "Invoice Order Failed");
                });
            } else if (e.itemData.menuText == "Send ASN") {
              SalesOrderEDIService.sendSalesOrderEDIASN(salesOrder)
                // eslint-disable-next-line no-unused-vars
                .then((result) => {
                  this.showLoading(false);
                  this.$notify(
                    `Successfully queued ASN for Sales Order ${salesOrder}`,
                    "success"
                  );

                  this.getSalesOrder();
                  // this.$logger.debug("result ", result);
                })
                .catch((error) => {
                  this.showLoading(false);
                  this.displayServerError(error, "Send ASN Failed");
                });
            } else if (e.itemData.menuText == "Send INV") {
              SalesOrderEDIService.sendSalesOrderEDIINV(salesOrder)
                // eslint-disable-next-line no-unused-vars
                .then((result) => {
                  this.showLoading(false);
                  this.$notify(
                    `Successfully queued INV for Sales Order ${salesOrder}`,
                    "success"
                  );

                  this.getSalesOrder();
                  // this.$logger.debug("result ", result);
                })
                .catch((error) => {
                  this.showLoading(false);
                  this.displayServerError(error, "Send INV Failed");
                });
            }
          },
        },
      },
      menu: {
        icon: "overflow",
      },
      columns: [
        {
          caption: "",
          dataField: "ItemCode",
          width: 60,
          alignment: "left",
          allowEditing: false,
          cellTemplate: "primaryImageTemplate",
          allowFiltering: false,
        },
        {
          caption: "Item",
          dataField: "ItemCode",
          sortOrder: "asc",
          width: 190,
          alignment: "left",
        },
        {
          caption: "Description",
          dataField: "ItemDescription",
          alignment: "left",
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          width: 200,
          alignment: "right",
          format: this.getDecimalFormatByCode(7).Format,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          width: 100,
          alignment: "left",
        },
        {
          caption: "SSCC",
          dataField: "SSCC",
          width: 200,
          sortOrder: "asc",
          alignment: "left",
        },

        {
          caption: "",
          dataField: "",
          width: 50,
          cellTemplate: "menu-cell-template",
        },
      ],
      selectedCode: null,
    };
  },
  created() {
    this.model.Name = `Sales Order # ${this.baseView.id}`;
    this.selectedIndex = 2;
    this.getSalesOrder();
  },

  computed: {
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    statusFriendly() {
      let status =
        this.model.Status == "" ? "D" : this.model.Status.toUpperCase();
      if (status !== "X" && this.model.Status !== "C") {
        if (
          this.model.IsLockedForPicking !== undefined &&
          this.model.IsLockedForPicking.toUpperCase() === "Y"
        ) {
          status = "L";
        }
      }

      return status;
    },
    dataSourceConfig() {
      return SalesOrderEDIService.dataSourceConfig({
        select: [
          "HasPrimaryImage",
          "ItemCode",
          "ItemDescription",
          "SalesOrderCode",
          "SalesOrderLineNo",
          "SalesOrderSSCCSequence",
          "SalesUM",
          "SSCC",
          "Status",
          "SalesUMQty",
        ],
        filter: [
          ["Status", "=", "A"],
          "and",
          ["SalesOrderCode", "=", parseInt(this.baseView.id)],
        ],
        sort: [{ selector: "SalesOrderCode", desc: true }],
      });
    },
    tabs() {
      return [
        {
          text: this.isTablet ? "Header" : "Order",
          path: `/sales-order/review/${this.baseView.id}/header`,
          applicationFeatureCode: "SalesOrder",
        },
        {
          text: "Details",
          path: `/sales-order/review/${this.baseView.id}/details`,
          applicationFeatureCode: "SalesOrder",
          visible: this.isTablet,
        },
        {
          text: "EDI",
          path: `/sales-order-edi/${this.baseView.id}`,
          applicationFeatureCode: "SalesOrderEDI",
        },
      ];
    },
  },

  methods: {
    repaintGrid() {
      if (this.$refs["salesorderedigrid"]) {
        let grid = this.$refs["salesorderedigrid"].instance;
        grid.repaint();
      }
    },

    getSalesOrder() {
      let that = this;
      let disableInvoiceOrder = false;
      let disableASN = false;
      let disableINV = false;

      SalesOrderService.getByCode(this.baseView.id).then((response) => {
        that.model.CustomerName = response.data.value[0].Customer.Name;
        that.model.CustomerCode = response.data.value[0].CustomerCode;
        that.model.Status = response.data.value[0].Status;

        if (that.model.Status == "P") {
          disableASN = true;
          disableINV = true;
          disableInvoiceOrder = true;
        }
        // eslint-disable-next-line no-unused-vars
        SalesOrderEDIService.getTop1Invoice(this.baseView.id).then(
          (response2) => {
            if (response2.data.value.length == 1) {
              disableInvoiceOrder = true;
            }
            SalesOrderEDIService.getEDICustomerDocumentTypeByCustomerCode(
              this.model.CustomerCode
            ).then((res3) => {
              let asnResult = res3.data.value.filter(
                (a) => a.EDIDocumentTypeCode == "ASN"
              );
              let invResult = res3.data.value.filter(
                (a) => a.EDIDocumentTypeCode == "INV"
              );

              if (asnResult == null || asnResult == "") {
                disableASN = true;
              }
              if (invResult == null || invResult == "") {
                disableINV = true;
              }

              SalesOrderEDIService.getSalesOrderEDIByCode(
                this.baseView.id
              ).then((res2) => {
                if (res2.data.value.length > 0) {
                  if (res2.data.value[0].ASNSent == "Y") {
                    disableASN = true;
                  }

                  if (res2.data.value[0].INVSent == "Y") {
                    disableINV = true;
                  }
                }

                that.toolbar.menu.items[1].disabled = disableInvoiceOrder;
                that.toolbar.menu.items[2].disabled = disableASN;
                that.toolbar.menu.items[3].disabled = disableINV;
                that.repaintGrid();
              });
            });
          }
        );

        // that.refreshView();
      });
    },
    onItemClick(e) {
      if (e.itemData.menuText == "Print SSCC Label") {
        this.showLoading(true);
        let rowData = e.itemData.data.data;
        SalesOrderEDIService.printSSCC(rowData.SSCC)
          // eslint-disable-next-line no-unused-vars
          .then((result) => {
            this.showLoading(false);
            this.$notify(
              `Successfully queued SSCC label ${rowData.SSCC} for printing`,
              "success"
            );
            // this.$logger.debug("result ", result);
          })
          .catch((error) => {
            this.showLoading(false);
            this.displayServerError(error, "Print SSCC Label Failed");
          });
      }
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/sales-order",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;

      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = ["searchPanel"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,
        {
          location: "after",
          template: "statusTemplate",
        },
        {
          options: this.toolbar.menu,
          location: "after",
          widget: "dxDropDownButton",
          visible: this.formsConfig.editableOption,
          ref: "gridMenu",
        }
      );
    },
  },
};
</script>
